import { Box, Button, Stack, Typography, useTheme } from '@mui/material';
import React from 'react';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

const Citation = ({ title, type, url, snippet }) => {
	const theme = useTheme();

	return (
		<Box
			sx={{
				p: 1.1,
				borderRadius: 2,
				backgroundColor: theme.palette.action.hover,
			}}
		>
			<Stack
				direction='row'
				alignItems='flex-start'
				justifyContent='space-between'
				spacing={1}
			>
				<Box
					sx={{
						minWidth: 0,
					}}
				>
					<Typography
						variant='body2'
						fontWeight={700}
						sx={{
							color: theme.palette.text.primary,
						}}
					>
						{title}
					</Typography>
					<Typography
						variant='caption'
						sx={{
							color: theme.palette.text.secondary,
						}}
					>
						{type}
					</Typography>
				</Box>
				{url && (
					<Button
						component='a'
						href={url}
						target='_blank'
						rel='noreferrer'
						size='small'
						endIcon={
							<ArrowOutwardIcon
								sx={{
									fontSize: 15,
								}}
							/>
						}
						sx={{
							flexShrink: 0,
							minWidth: 0,
							borderRadius: 999,
							textTransform: 'none',
							color: theme.palette.folioPurple,
						}}
					>
						Open
					</Button>
				)}
			</Stack>
			{snippet && (
				<Typography
					variant='body2'
					sx={{
						mt: 0.9,
						color: theme.palette.text.secondary,
						lineHeight: 1.65,
					}}
				>
					{snippet}
				</Typography>
			)}
		</Box>
	);
};

export default Citation;
